module.exports = __webpack_public_path__ + "static/media/matilde-cap-sri-lanka-impressed.7b934602.png";